import { u as f } from "./use-gls-global-translation-DTDPyT8A.js";
import { g as L } from "./gls-translate-Bw61wOEs.js";
import { c as r } from "./vue-i18n-DUK6L89c.js";
const l = "language", n = () => {
  let e = localStorage.getItem(l);
  return e || (e = "en"), e;
}, o = (e) => {
  localStorage.setItem(l, e);
}, g = (e, t = {}) => r({
  legacy: !1,
  locale: n() || "en",
  fallbackLocale: "en",
  messages: e,
  pluralRules: {
    pl: (a) => a === 1 ? 0 : a < 10 && [2, 3, 4].includes(a) || a > 20 && [2, 3, 4].includes(a % 10) ? 1 : 2,
    ...t
  }
});
export {
  g as glsCreateI18nInstance,
  n as glsGetLanguageFromLocalStorage,
  o as glsSetLanguageInLocalStorage,
  L as glsTranslate,
  f as useGlsGlobalTranslation
};
